// extracted by mini-css-extract-plugin
export default {"mainReviewsWrapper":"AH-z"};